import React, {useState, useContext} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../util/ErrorBoundaryForComponents';

import FilterGroupSearchTable from './FilterGroupSearchTable';
import {ThemeContext} from '../../../themes/ThemeProvider';

const SearchFilterGroupContainer = ({
  setTabValue,
  handleClose,
  setRecordFormatFilterGroupCode,
  setRecordFormatFilterGroupId,
  setSelectedFilterGroupCode,
  setFilterGroupCode,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const initialValues = {
    code: '',
    displayName: '',
    description: '',
  };
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
  };

  return (
    <div>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
      >
        {(props) => {
          const {values, handleChange, handleReset, handleBlur} = props;
          return (
            <div>
              <Form autoComplete="off" noValidate>
                <ErrorBoundaryForComponents>
                  <Grid container spacing={2}>
                    <>
                      <Grid item xs={6} xl={4} md={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Filter Group Code`}
                          label="Filter Group Code"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="code"
                          value={values.code}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={6} xl={4} md={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Filter Group Name`}
                          label="Filter Group Name"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="displayName"
                          value={values.displayName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={6} xl={4} md={4} className="form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Filter Group Description`}
                          label="Filter Group Description"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </Grid>
                    </>
                  </Grid>
                </ErrorBoundaryForComponents>

                <div className="button-table-spacing-mb">
                  <Button
                    variant="contained"
                    className={`mx-1 ${classes.buttonRoot}`}
                    onClick={() => {
                      setSubmit(true);
                      handleReset();
                      setSearchData(initialValues);
                    }}
                  >
                    Clear
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
                  >
                    Search
                  </Button>
                </div>
              </Form>
            </div>
          );
        }}
      </Formik>
      <FilterGroupSearchTable
        submit={submit}
        setSubmit={setSubmit}
        setFilterGroupCode={setFilterGroupCode}
        setSelectedFilterGroupCode={setSelectedFilterGroupCode}
        setTabValue={setTabValue}
        searchData={searchData}
        handleClose={handleClose}
        setRecordFormatFilterGroupCode={setRecordFormatFilterGroupCode}
        setRecordFormatFilterGroupId={setRecordFormatFilterGroupId}
      />
    </div>
  );
};

export default SearchFilterGroupContainer;
